import React from 'react';
import { Paper, Typography, Stack, Box } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';
import { 
  RecurringTaskGeneralTicketTitleEditor, 
  RecurringTaskGeneralTicketDescriptionEditor 
} from '../fields/generalTicketTemplate';

/**
 * RecurringTaskGeneralTicketTemplateSection - Section for defining the ticket template for GEN category
 * This defines the title and description that will be used when creating tickets from this recurring task
 */
export const RecurringTaskGeneralTicketTemplateSection: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 1.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <DescriptionOutlined sx={{ color: '#3b82f6', fontSize: 20 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b' }}>
          Ticket Template
        </Typography>
      </Box>
      
      <Stack direction="column" spacing={2}>
        <RecurringTaskGeneralTicketTitleEditor />
        <RecurringTaskGeneralTicketDescriptionEditor />
      </Stack>
    </Paper>
  );
};

export default RecurringTaskGeneralTicketTemplateSection;
